import { UserForIdentificationSelect } from '@erikdakoda/auth/types';
import type {
  ComposioConnectionGetPayload,
  ComposioConnectionSelect,
} from '@erikdakoda/database/types';

/** Select for Composio connection rows displayed in admin data grids. */
export const ConnectionForGridSelect = {
  id: true,
  itemType: true,
  ownerId: true,
  owner: { select: UserForIdentificationSelect },
  scope: true,
  toolAccessMode: true,
  connectorKey: true,
  serviceKey: true,
  connectionUserId: true,
  toolkitSlug: true,
  toolkitName: true,
  toolkitLogo: true,
  authScheme: true,
  status: true,
  statusReason: true,
  name: true,
  isDefault: true,
  initiatedAt: true,
  connectedAt: true,
  lastVerifiedAt: true,
  expiredAt: true,
  disabledAt: true,
  createdAt: true,
  updatedAt: true,
} as const satisfies ComposioConnectionSelect;

/** Composio connection row shape used by the administrative data grid. */
export type ConnectionForGrid = ComposioConnectionGetPayload<{
  select: typeof ConnectionForGridSelect;
}>;

/** Select for the user-facing Connections panel / card — never includes `@omit`ted columns. */
export const ConnectionForCardSelect = {
  id: true,
  itemType: true,
  scope: true,
  toolAccessMode: true,
  connectorKey: true,
  toolkitSlug: true,
  toolkitName: true,
  toolkitLogo: true,
  authScheme: true,
  status: true,
  statusReason: true,
  name: true,
  isDefault: true,
  initiatedAt: true,
  connectedAt: true,
  lastVerifiedAt: true,
  expiredAt: true,
  disabledAt: true,
} as const satisfies ComposioConnectionSelect;

/** Composio connection row shape used by `ConnectionCard` / `ConnectionsPanel`. */
export type ConnectionForCard = ComposioConnectionGetPayload<{
  select: typeof ConnectionForCardSelect;
}>;
